export default class TipoDocumento {
    constructor() {
        this.Codigo = 0;
        this.Descripcion = ""
    }

    Codigo: number;

    Descripcion: string;

}